import React from 'react'
import Typography from '@mui/material/Typography';
import { Card } from '@mui/material';

export default function ChatMessage({message}) {
  return (
    <div 
      className='live-call-chat-message'
      style={{ flexDirection: message.LocalUser ? 'row-reverse' : 'row' }}
    >
      {message.Avatar}
      <div className='live-call-chat-message-content'>
        <div className='live-call-chat-message-content-header'>
          <Typography variant='body2' gutterBottom>
            {message.Channel.caller.name}
          </Typography>
          <Typography variant='caption' color='primary'>
            {message.Timestamp.toLocaleTimeString()}
          </Typography>
        </div>
        <Card sx={{padding: '8px', backgroundColor: message.LocalUser ? 'var(--live-call-color-bg)' : null}}>
            <Typography align='left' variant='body2' color='text.secondary'>
              {message.Body}
            </Typography>
        </Card>
      </div>
    </div>
  )
}